<template>
  <div>
    <v-card width="100%" class="mx-auto">
      <v-card-title class="justify-center">
        <b>{{ $t('SpecificCompensation.Pending Compensations') }}</b>
      </v-card-title>

      <Loading v-if="loading" />
      <div v-if="factoring">
        <PendingFactoringItem :factoring="factoring" :user-prop="user" class="pb-0" @refresh="inicialize()" />
      </div>
    </v-card>
  </div>
</template>

<script>
import Loading from "../components/Loading";
import ApiRepository from "../repositories/ApiRepository";
import PendingFactoringItem from "../components/factoring/PendingFactoringItem";
import LocalRepository from "../repositories/LocalRepository";

export default {
    name: "SpecificCompensation",
    components: { Loading, PendingFactoringItem},
    data () {
        return {
            state: null,
            idFactoring: null,
            factoring: null,
            loading: true,
            user: null,
            topChangeText: {
                pulling: this.$t('Refreshing') + "...",
                limit: this.$t('Refreshing') + "...",
                loading: this.$t('Refreshing') + "...",
                complete: "  ",
            },
        };
    },
    created () {
        this.inicialize();
    },
    methods: {
        inicialize () {
            const userId = this.$route.query.userId;
            this.idFactoring = this.$route.query.id;
            ApiRepository.getUserById(userId)
                .then((res) => {
                    this.user = res.data.user;
                    this.fetch();
                    LocalRepository.set('cif-user-compensation', res.data.user.cif);
                })
                .catch((err) => {
                    console.log(err);
                    this.$root.$emit('show-snackbar', {message: this.$t('Error.User not found'), color: 'error'});
                });
        },
        fetch () {
            if (this.idFactoring) {
                ApiRepository.getFactoringById(this.idFactoring)
                    .then((res) => {
                        this.factoring = res.data.factoring;
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$root.$emit('show-snackbar', {message: this.$t('Error.Something went wrong'), color: 'error'});
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            } else {
                this.loading = false;
            }
        },
        handleTop () {
            setTimeout(() => {
                this.fetch();
                this.$refs.vueLoad.onTopLoaded(0);
            }, 1000);
        },
        disconectUser (id) {
            if (this.$user && this.$user._id !== id) {
                LocalRepository.clear('token');
                location.reload();
            }
        }
    },
    sockets: {
        REFRESH_COMPENSATIONS () {
            this.inicialize();
        }
    },
};
</script>

<style scoped>

</style>
